// extracted by mini-css-extract-plugin
module.exports = {"label":"sender-id_label__1UKlQ","hidden":"sender-id_hidden__2bYo_","inputForm":"sender-id_inputForm__LNOut"};